var _defs, _style, _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 204 73",
    width: 204,
    height: 73,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m203.16 0v72.1h-203.16v-72.1z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre } \n\t\t.t0 { font-size: 30px;fill: #ffffff;font-weight: 400;font-family: \"FredokaOne-Regular\", \"Fredoka One\" } \n\t")), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Group_1",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "NABAZAT  AL QALB",
    style: {
      transform: "matrix(.981,0,0,.986,-0.981,5.919)"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 32.6,
    y: 23.2,
    className: "t0"
  }, "N")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    y: 23.2,
    className: "t0"
  }, "A")), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    y: 23.2,
    className: "t0"
  }, "B")), _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    y: 23.2,
    className: "t0"
  }, "A")), _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    y: 23.2,
    className: "t0"
  }, "ZAT")), _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    y: 23.2,
    className: "t0"
  })), _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    y: 23.2,
    className: "t0"
  })), _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 38.5,
    y: 59.2,
    className: "t0"
  }, "A")), _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    y: 59.2,
    className: "t0"
  }, "L")), _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    y: 59.2,
    className: "t0"
  }, " QALB")), _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    y: 59.2,
    className: "t0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4b470c53cdf74e8144677719376ccc7e.svg";
export { ForwardRef as ReactComponent };